__turbopack_context__.v({
  "content_box": "bnwM_W_content_box",
  "grid_block": "bnwM_W_grid_block",
  "homepageWrapper": "bnwM_W_homepageWrapper",
  "logo_wrapper": "bnwM_W_logo_wrapper",
  "main_wrapper": "bnwM_W_main_wrapper",
  "question_layout": "bnwM_W_question_layout",
  "question_layout_wrapper": "bnwM_W_question_layout_wrapper",
});
